import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=2cfb5916&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"
import style1 from "./ContactsView.vue?vue&type=style&index=1&id=2cfb5916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb5916",
  null
  
)

export default component.exports